// extracted by mini-css-extract-plugin
module.exports = {"muted":"_2C1Wx___Emdash-module__muted"};